export default __webpack_public_path__ + "static/media/Frame 19.1ea98a56.png";